export const encPortals = ['CO'];
